import { graphql } from '~/gql';

export const SeminarFragment = graphql(`
  fragment ProductLpTemplateSeminarFragment on Seminar {
    ...ProductLpTemplateSeminarSectionSeminarFragment
  }
`);

const query = graphql(`
  query ProductLpDevKeywordsQuery($keywords: [String!]!) {
    filterSeminars(
      first: 7
      after: null
      filter: { isApplicable: true, categories: [], keywords: $keywords }
    ) {
      edges {
        node {
          ...ProductLpTemplateSeminarFragment
        }
      }
    }
  }
`);

export const useProductLpDevKeywordsQuery = async (variables: {
  keywords: string[];
}) => {
  const { data, execute } = useLazyAsyncQuery(query, variables);
  await execute();

  return {
    data,
  };
};
